module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": 'https://www.weddingsung.com/songs/' + _vm.videoId,
      "data-width": "800",
      "data-numposts": "5"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333f7c9d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fbcomment.vue
// module id = 158
// module chunks = 1